import { useTranslation } from "react-i18next";

export default function AuthLayout({ children }) {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-grid-pattern opacity-5"></div>

      {/* Main Content */}
      <div className="relative z-10">
        {/* Header */}
        <header className="absolute top-0 left-0 right-0 z-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between h-16">
              {/* Logo */}
              <div className="flex items-center">
                <img
                  className="h-12 w-auto"
                  src="/omnidoc-logo.png"
                  alt="Logo"
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
                {/* <span className="ml-3 text-xl font-bold text-gray-900 dark:text-white">
                  {t("app.title")}
                </span> */}
              </div>

              {/* Language Selector */}
              <div className="flex items-center space-x-4">
                <select
                  className="bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-md px-3 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  defaultValue="fr"
                >
                  <option value="fr">Français</option>
                  <option value="en">English</option>
                </select>
              </div>
            </div>
          </div>
        </header>

        {/* Content */}
        <main className="pt-16">{children}</main>

        {/* Footer */}
        {/* <footer className="absolute bottom-0 left-0 right-0 p-4 text-center text-sm text-gray-500 dark:text-gray-400">
          <p>
            Développé avec ❤️ pour la gestion moderne des ressources humaines
          </p>
        </footer> */}
      </div>
    </div>
  );
}



























